import { t } from "i18next";

export const getProductImageAltText = (productName: string): string => {
  return t("aria.productImageAltText", { productName: productName });
};
